export const PLAYBACK_STATE = {
  PLAY: 1,
  PAUSE: 2,
  STOP: 3,
} as const

export const PLAYER_TYPE = {
  MEDIA: 'media',
  TIMELINE: 'timeline',
} as const

export const DRAGNDROP_TYPE = {
  MEDIA_ITEM: 'media-item',
  IMAGE_ITEM: 'image-item',
  LAYER_ASSET: 'layer-asset',
  TEXT_ITEM: 'text-item',
  AUDIO_ITEM: 'audio-item',
  TRANSITION_ITEM: 'transition-item',
  LAYER_TRANSITION_ASSET: 'transition-asset',
  LAYER: 'layer',
  FOLDER: 'folder',
  GROUP: 'group',
  PREVIEW_MEDIA_ITEM: 'preview-media-iteml',
  NATIVE_FILE: '__NATIVE_FILE__',
  SOURCE_LIST_HEADER: 'SOURCE_LIST_HEADER',
  TIMELINE_PANEL: 'TIMELINE_PANEL',
} as const

export const DROP_TARGET_TYPE = {
  ROOT: 'root',
  TIMELINE: 'timeline',
  SOURCE_MEDIA: 'sourceMedia',
} as const

export const TRANSITIONS = {
  DISSOLVE: 'dissolve',
  FADEIN: 'fadein',
  FADEOUT: 'fadeout',
  DIP_BLACK: 'dip-to-black',
  DIP_WHITE: 'dip-to-white',
  BLUR: 'blur',
  WIPE_RIGHT: 'wipe-right',
  WIPE_LEFT: 'wipe-left',
  WIPE_UP: 'wipe-up',
  WIPE_DOWN: 'wipe-down',
} as const

export const TRANSITION_MOUNT_TYPE = {
  IN: 'mount_in',
  OUT: 'mount_out',
  BETWEEN: 'mount_between',
} as const

export const TEXTS = {
  DEFAULT_TEXT: 'text',
}

export const MENU_ITEMS = {
  MEDIA: 'Media',
  PROJECT_MEDIA: 'ProjectMedia',
  TRANSITIONS: 'Transitions',
  TEXT: 'Text',
  AUDIO: 'Audio',
  FILTERS: 'Filters',
  DESIGN: 'Design',
  IMAGES: 'Images',
  VIDEOS: 'Videos',
} as const

export const TASK_STATUS = {
  NEW: 'new',
  PREPARE_IMAGES: 'prepare_images',
  RUNNING: 'running',
  COMPLETED: 'completed',
  DOWNLOADING: 'downloading',
  UPLOADING: 'uploading',
  ABORTED: 'aborted',
  CONVERT: 'convert',
}

export const SOURCE_FILE_TYPES = {
  MEDIA: 'Media', // collection of any user's files: video/audio/image
  PROJECT_MEDIA: 'ProjectMedia',
  TRANSITIONS: 'Transitions',
  TEXT: 'Text',
  AUDIO: 'Audio',
  FILTERS: 'Filters',
  DESIGN: 'Design',
  IMAGES: 'Images',
} as const

export const MEDIA_FILE_FILTERS = {
  All: 'all',
  Video: 'video',
  Image: 'image',
  Audio: __APP_PROFILE__ === 'vrspot' ? 'audio' : 'audio,voiceover',
  Folder: 'folder',
  Voiceover: 'voiceover',
} as const

export const EXCLUDE_FILTERS = {
  [MENU_ITEMS.PROJECT_MEDIA]: [ MEDIA_FILE_FILTERS.Folder ],
}

export const MEDIA_FILES_VIEW = {
  List: 'List',
  Icons: 'Icons',
}

export const MEDIA_FILES_ORDER = {
  Ascending: 'asc',
  Descending: 'desc',
} as const

export const MEDIA_FILES_SORT = {
  Name: 'name',
  Date: 'createTime',
  Size: 'size',
  Duration: 'duration',
} as const

export const TEXT_POSITION = {
  TOP_LEFT: 'topLeft',
  TOP: 'top',
  TOP_RIGHT: 'topRight',
  RIGHT: 'right',
  BOTTOM_RIGHT: 'bottomRight',
  BOTTOM: 'bottom',
  BOTTOM_LEFT: 'bottomLeft',
  LEFT: 'left',
  MIDDLE_CENTER: 'middleCenter',
}

export const TEXT_TRANSFORM = {
  NONE: 'none',
  UPPERCASE: 'uppercase',
  LOWERCASE: 'lowercase',
  CAPITALIZE: 'capitalize',
}

export const FILE_TYPE = {
  UPLOADED: 'uploaded',
  TEST: 'test',
  OUTPUT: 'output',
  URL: 'url',
  AWS: 'aws',
  DEVMEDIA: 'devmedia',
  JSONMEDIA: 'jsonmedia',
  VOICEOVER: 'voiceover',
  FOLDER: 'folder',
  LIVE_STREAM: 'livestream',
  MYVRSPOT: 'myvrspot',
  IMAGE_OVERLAY: 'imgoverlay',
  TEST_USER: 'testuser',
  LIVESTREAM: 'livestream',
  TEMPLATE: 'template',
  AUDIO_LIB: 'audiolib',
  LOCAL: 'local',
  EXTAUDIOLIB: 'extaudiolib',
  IMAGE_LIB_PEXELS: 'imagelibpexels',
  IMAGE_LIB_UNSPLASH: 'imagelibunsplash',
  IMAGE_LIB: 'imagelib',
  EXTIMAGELIB: 'extimagelib',
  UNKNOWN: 'unknown',
  EXAMPLE: 'example',
} as const

export const FILE_LOCAL_TYPE = {
  TEXT: 'text',
  TRANSITION: 'transition',
} as const


export const FILE_FETCH_URL_PATH = {
  [FILE_TYPE.MYVRSPOT]: '/api/mediafiles',
  [FILE_TYPE.DEVMEDIA]: '/api/mediafiles',
  [FILE_TYPE.IMAGE_OVERLAY]: '',
  [FILE_TYPE.TEST]: '/api/mediafiles',
  [FILE_TYPE.TEST_USER]: '/api/mediafiles',
  [FILE_TYPE.OUTPUT]: '/api/mediafiles',
  [FILE_TYPE.UPLOADED]: '/api/mediafiles',
  [FILE_TYPE.URL]: '/api/mediafiles',
  [FILE_TYPE.AWS]: '/api/mediafiles',
  [FILE_TYPE.VOICEOVER]: '/api/mediafiles',
  [FILE_TYPE.LIVESTREAM]: '/api/mediafiles',
  [FILE_TYPE.TEMPLATE]: '',
  [FILE_TYPE.AUDIO_LIB]: '/api/audiolib_files',
  [FILE_TYPE.LOCAL]: '/api/mediafiles',
  [FILE_TYPE.FOLDER]: '',
  [FILE_TYPE.EXTAUDIOLIB]: '/api/audiolib_files',
  [FILE_TYPE.IMAGE_LIB_PEXELS]: '/api/imagelib_files',
  [FILE_TYPE.IMAGE_LIB_UNSPLASH]: '/api/imagelib_files',
  [FILE_TYPE.IMAGE_LIB]: '/api/imagelib_files',
  [FILE_TYPE.EXTIMAGELIB]: '/api/imagelib_files',
  [FILE_TYPE.JSONMEDIA]: '/api/mediafiles',
  [FILE_TYPE.UNKNOWN]: '',
  [FILE_TYPE.EXAMPLE]: '',
} as const

export const MEDIA_TYPE = {
  MP4: 'mp4',
  MOV: 'mov',
  MP3: 'mp3',
  PNG: 'png',
  M4A: 'm4a',
  JPG: 'jpg',
  MXF: 'mxf',
  HLS: 'm3u8',
  TS: 'ts',
  WEBM: 'webm',
  FOLDER: 'folder',
} as const

export const HOTKEY_CATEGORY = {
  All: 'ALL',
  Timeline: 'TIMELINE',
  Tools: 'TOOLS',
  Preview: 'PREVIEW',
}

export const HOTKEYS = {
  UNDO: 'TIMELINE_BTN_UNDO',
  REDO: 'TIMELINE_BTN_REDO',
  ZOOM_IN: 'TIMELINE_BTN_ZOOM_IN',
  ZOOM_OUT: 'TIMELINE_BTN_ZOOM_OUT',
  PREV_FRAME: 'PREVIEW_BTN_PREV_FRAME',
  NEXT_FRAME: 'PREVIEW_BTN_NEXT_FRAME',
  ADD_TO_TIMELINE: 'BTN_ADD_TO_TIMELINE',
  INCREASE_CLIP_VOLUME: 'INCREASE_CLIP_VOLUME',
  DECREASE_CLIP_VOLUME: 'DECREASE_CLIP_VOLUME',
  RIPPLE_DELETE: 'RIPPLE_DELETE',
  RIPPLE_TRIM_PREV: 'RIPPLE_TRIM_PREV',
  RIPPLE_TRIM_NEXT: 'RIPPLE_TRIM_NEXT',
  SELECT_CLIPS_AT_CURRENT_POSITION: 'SELECT_CLIPS_AT_CURRENT_POSITION',
  CUT_CLIPS: 'TIMELINE_BTN_CUT_CLIPS',
  PLAY_PAUSE: 'PREVIEW_BTN_PLAY_PAUSE',
  DELETE: 'BTN_DELETE',
  COPY: 'COPY',
  PASTE: 'PASTE',
  PLAY: 'PLAY',
  PAUSE: 'PAUSE',
  CLIP_SETTINGS: 'CLIP_SETTINGS',
  MARK_IN: 'MARK_IN',
  MARK_OUT: 'MARK_OUT',
  CLEAR_IN_OUT_MARK_POINTS: 'CLEAR_IN_OUT_MARK_POINTS',
  PLAY_TIMELINE_SEGMENT: 'PLAY_TIMELINE_SEGMENT',
  SEEK_TO_IN_POINT: 'SEEK_TO_IN_POINT',
  SEEK_TO_OUT_POINT: 'SEEK_TO_OUT_POINT',
  NEXT_EDITING_POINT: 'NEXT_EDITING_POINT',
  PREV_EDITING_POINT: 'PREV_EDITING_POINT',
  TOGGLE_MY_MEDIA_VISIBLE: 'TOGGLE_MY_MEDIA_VISIBLE',
  TOGGLE_SETTINGS_VISIBLE: 'TOGGLE_SETTINGS_VISIBLE',
} as const

export const EMPTY_HOTKEY_COMBINATION = ''
export const EXCLUDE_HOTKEY = 'exclude'

export const HOTKEY_SETTINGS_LABELS = {
  [HOTKEYS.UNDO]: 'HOTKEY_SETTINGS_UNDO',
  [HOTKEYS.REDO]: 'HOTKEY_SETTINGS_REDO',
  [HOTKEYS.ZOOM_IN]: 'HOTKEY_SETTINGS_ZOOM_IN',
  [HOTKEYS.ZOOM_OUT]: 'HOTKEY_SETTINGS_ZOOM_OUT',
  [HOTKEYS.PREV_FRAME]: 'HOTKEY_SETTINGS_PREV_FRAME',
  [HOTKEYS.NEXT_FRAME]: 'HOTKEY_SETTINGS_NEXT_FRAME',
  [HOTKEYS.ADD_TO_TIMELINE]: 'HOTKEY_SETTINGS_ADD_TO_TIMELINE',
  [HOTKEYS.INCREASE_CLIP_VOLUME]: 'HOTKEY_SETTINGS_INCREASE_CLIP_VOLUME',
  [HOTKEYS.DECREASE_CLIP_VOLUME]: 'HOTKEY_SETTINGS_DECREASE_CLIP_VOLUME',
  [HOTKEYS.RIPPLE_DELETE]: 'HOTKEY_SETTINGS_RIPPLE_DELETE',
  [HOTKEYS.RIPPLE_TRIM_PREV]: 'HOTKEY_SETTINGS_RIPPLE_TRIM_PREV',
  [HOTKEYS.RIPPLE_TRIM_NEXT]: 'HOTKEY_SETTINGS_RIPPLE_TRIM_NEXT',
  [HOTKEYS.SELECT_CLIPS_AT_CURRENT_POSITION]: 'HOTKEY_SETTINGS_SELECT_CLIPS_AT_CURRENT_POSITION',
  [HOTKEYS.CUT_CLIPS]: 'HOTKEY_SETTINGS_CUT_CLIPS',
  [HOTKEYS.PLAY_PAUSE]: 'HOTKEY_SETTINGS_PLAY_PAUSE',
  [HOTKEYS.DELETE]: 'HOTKEY_SETTINGS_DELETE',
  [HOTKEYS.COPY]: 'HOTKEY_SETTINGS_COPY',
  [HOTKEYS.PASTE]: 'HOTKEY_SETTINGS_PASTE',
  [HOTKEYS.PLAY]: 'HOTKEY_SETTINGS_PLAY',
  [HOTKEYS.PAUSE]: 'HOTKEY_SETTINGS_PAUSE',
  [HOTKEYS.CLIP_SETTINGS]: 'CLIP_SETTINGS',
  [HOTKEYS.MARK_IN]: 'HOTKEY_SETTINGS_MARK_IN',
  [HOTKEYS.MARK_OUT]: 'HOTKEY_SETTINGS_MARK_OUT',
  [HOTKEYS.CLEAR_IN_OUT_MARK_POINTS]: 'HOTKEY_SETTINGS_CLEAR_IN_OUT_MARK_POINTS',
  [HOTKEYS.PLAY_TIMELINE_SEGMENT]: 'HOTKEY_SETTINGS_PLAY_TIMELINE_SEGMENT',
  [HOTKEYS.SEEK_TO_IN_POINT]: 'HOTKEY_SETTINGS_SEEK_TO_IN_POINT',
  [HOTKEYS.SEEK_TO_OUT_POINT]: 'HOTKEY_SETTINGS_SEEK_TO_OUT_POINT',
  [HOTKEYS.NEXT_EDITING_POINT]: 'HOTKEY_SETTINGS_NEXT_EDITING_POINT',
  [HOTKEYS.PREV_EDITING_POINT]: 'HOTKEY_SETTINGS_PREV_EDITING_POINT',
  [HOTKEYS.TOGGLE_MY_MEDIA_VISIBLE]: 'HOTKEY_SETTINGS_TOGGLE_MY_MEDIA_VISIBLE',
  [HOTKEYS.TOGGLE_SETTINGS_VISIBLE]: 'HOTKEY_SETTINGS_TOGGLE_SETTINGS_VISIBLE',
}

export const DEFAULT_HOTKEYS = {
  [HOTKEYS.UNDO]: 'CTRL + KeyZ',
  [HOTKEYS.REDO]: 'CTRL + KeyY',
  [HOTKEYS.ADD_TO_TIMELINE]: 'SHIFT + Equal',
  [HOTKEYS.DECREASE_CLIP_VOLUME]: 'BracketLeft',
  [HOTKEYS.INCREASE_CLIP_VOLUME]: 'BracketRight',
  [HOTKEYS.PREV_FRAME]: 'ArrowLeft',
  [HOTKEYS.NEXT_FRAME]: 'ArrowRight',
  [HOTKEYS.ZOOM_IN]: 'Equal',
  [HOTKEYS.ZOOM_OUT]: 'Minus',
  [HOTKEYS.RIPPLE_DELETE]: 'KeyT',
  [HOTKEYS.RIPPLE_TRIM_PREV]: 'KeyQ',
  [HOTKEYS.RIPPLE_TRIM_NEXT]: 'KeyW',
  [HOTKEYS.SELECT_CLIPS_AT_CURRENT_POSITION]: 'KeyD',
  [HOTKEYS.CUT_CLIPS]: 'KeyK',
  [HOTKEYS.PLAY_PAUSE]: 'Space',
  [HOTKEYS.DELETE]: 'Delete',
  [HOTKEYS.COPY]: 'CTRL + KeyC',
  [HOTKEYS.PASTE]: 'CTRL + KeyV',
  [HOTKEYS.CLIP_SETTINGS]: 'ALT + KeyS',
  [HOTKEYS.MARK_IN]: 'KeyI',
  [HOTKEYS.MARK_OUT]: 'KeyO',
  [HOTKEYS.CLEAR_IN_OUT_MARK_POINTS]: 'Alt + KeyX',
  [HOTKEYS.PLAY_TIMELINE_SEGMENT]: 'Alt + Slash',
  [HOTKEYS.SEEK_TO_IN_POINT]: 'SHIFT + KeyI',
  [HOTKEYS.SEEK_TO_OUT_POINT]: 'SHIFT + KeyO',
  [HOTKEYS.PLAY]: EMPTY_HOTKEY_COMBINATION,
  [HOTKEYS.PAUSE]: EMPTY_HOTKEY_COMBINATION,
  [HOTKEYS.NEXT_EDITING_POINT]: 'ArrowUp',
  [HOTKEYS.PREV_EDITING_POINT]: 'ArrowDown',
  [HOTKEYS.TOGGLE_MY_MEDIA_VISIBLE]: 'Alt + KeyM',
  [HOTKEYS.TOGGLE_SETTINGS_VISIBLE]: 'CTRL + KeyK',
} as const

export const FILE_STATUS = {
  UPLOAD: 'upload',
  IMPORT: 'import',
  S3_UPLOAD: 's3_upload',
  MEDIAINFO: 'mediainfo',
  PREPARE_THUMBNAILS: 'prepare_thumbnails',
  READY: 'ready',
  RENDER: 'render',
  CONVERT: 'convert',
  CAPTURE: 'capture',
}

export const MEDIA_ERROR_TYPE = {
  BUILD_THUMBNAILS: 'build_thumbnails_error',
  UNSUPPORTED_MEDIA: 'unsupported_media',
  EXCEEDED_FILE_SIZE: 'exceeded_file_size',
  EXCEEDED_PER_USER_SIZE: 'exceeded_per_user_size',
  LOW_DISK_SPACE: 'low_disk_space',
  INTERNAL_SERVER_ERROR: 'internal_server_error',
  NETWORK_ERROR: 'network_error',
  NOT_FOUND: 'not_found',
  NOT_ENOUGH_TOKENS: 'not_enough_tokens',
}

export const HISTORY_EVENT_TYPE = {
  UNDO: 'undo',
  REDO: 'redo',
}

export const MEDIA_RECORDING_TYPE = { Audio: 'audio', Video: 'video', Live: 'live' } as const
export type TMEDIA_RECORDING_TYPE = typeof MEDIA_RECORDING_TYPE[keyof typeof MEDIA_RECORDING_TYPE]
export type TransitionType = typeof TRANSITIONS[keyof typeof TRANSITIONS]
export const PROJECT_TYPE = {
  edlZip: '.edl.zip',
  // edl: '.edl',
  jsonZip: '.json.zip',
  // json: '.json',
  // xtl: '.xtl',
} as const

export const RENDER_BACKEND = {
  SOLVEIG: 'solveig',
  SHOTSTACK: 'shotstack',
}

export const IMAGES_SOURCES = {
  Native: 'json',
  Pexels: 'pexels',
  Unsplash: 'unsplash',
}

export const DIRECTION = {
  RIGHT: 'right',
  LEFT: 'left',
}

export const NW_JS_APP_PROFILES = [ 'desktop', 'itochu' ] as const

export const LANG = { EN: 'en', JAPAN: 'ja' } as const
export const HIEROGLYPH_LANG = [ LANG.JAPAN ]

export const REGULATION_CONTROL = {
  DECREASE: 'decrease',
  INCREASE: 'increase',
} as const

export const REGULAR_CONTROLS_UNITS = [
  REGULATION_CONTROL.DECREASE, REGULATION_CONTROL.INCREASE,
]

export const SEPARATOR = {
  COLON: ':',
  DOT: '.',
  SEMICOLON: ';',
  COMMA: ',',
} as const

export const PROJECT_EXPORT_TYPE = {
  EDL: 'edl',
  JSON: 'json',
}

export const SOURCE_FILE_PROPERTIES = {
  TEXTS: {
    DEFAULT: {
      NAME: 'Text',
      ID: 'example_text_uniqueid',
    },
  },
  TRANSITIONS: {
    DISSOLVE: {
      NAME: 'Dissolve',
      ID: 'example_transition_uniqueid_dissolve.mp4',
    },
    FADE_IN: {
      NAME: 'Fade In',
      ID: 'example_transition_uniqueid_fade_in.mp4',
    },
    FADE_OUT: {
      NAME: 'Fade Out',
      ID: 'example_transition_uniqueid_fade_out.mp4',
    },
    DIP_TO_BLACK: {
      NAME: 'Dip to Black',
      ID: 'example_transition_uniqueid_dip_black.mp4',
    },
    DIP_TO_WHITE: {
      NAME: 'Dip to White',
      ID: 'example_transition_uniqueid_dip_white.mp4',
    },
    BLUR: {
      NAME: 'Blur',
      ID: 'example_transition_uniqueid_blur.mp4',
    },
    WIPE_RIGHT: {
      NAME: 'Wipe Right',
      ID: 'example_transition_uniqueid_wipe_right.mp4',
    },
    WIPE_LEFT: {
      NAME: 'Wipe Left',
      ID: 'example_transition_uniqueid_wipe_left.mp4',
    },
    WIPE_UP: {
      NAME: 'Wipe Up',
      ID: 'example_transition_uniqueid_wipe_up.mp4',
    },
    WIPE_DOWN: {
      NAME: 'Wipe Down',
      ID: 'example_transition_uniqueid_wipe_down.mp4',
    },
  },
}

export const SIDEBAR_ICONS_ORDER = [
  MENU_ITEMS.MEDIA,
  MENU_ITEMS.PROJECT_MEDIA,
  MENU_ITEMS.TRANSITIONS,
  MENU_ITEMS.TEXT,
  MENU_ITEMS.AUDIO,
  MENU_ITEMS.FILTERS,
  MENU_ITEMS.DESIGN,
  MENU_ITEMS.IMAGES,
  MENU_ITEMS.VIDEOS,
]

export const PROJECT_INCREMENT_DISABLED = [ 'vrspot' ]

export const AUDIO_LIB_CATEGORY = {
  MUSIC: 'music',
  SOUND: 'sound',
  MOOD: 'mood',
}

export const INSTALL_COMPONENT = {
  WHISPER: 'whisper',
  HIGHLIGHTS: 'highlights',
} as const

export const WS_EVENT_TYPES = {
  USER_EVENT: 'user_event',
  PING_EVENT: 'ping',
  PONG_EVENT: 'pong',
  USER_INFO_EVENT: 'user_info',
  USER_BC_UPLOAD_MEDIA: 'user_bc_upload_media',
  USER_BC_DELETE_MEDIA: 'user_bc_delete_media',
  USER_BC_INSTALL_COMPONENT_COMPLETE: 'user_bc_install_component_complete',
} as const
